import {
  Component, Input, ElementRef, OnInit, ViewChild, ViewEncapsulation, HostListener
} from '@angular/core';
import { SliderModel } from '../../_interfaces';
import { AppState } from '../../app.service';

declare var Velocity: any;
declare var dataLayer: any;

@Component({
    selector: 'pq-imageslider',
    templateUrl: './image.slider.component.html',
    styleUrls: ['./_image.slider.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ImageSliderComponent implements OnInit {
  @ViewChild('slider', { static: true }) public slider: HTMLDivElement;

  @Input() public gaRelatedTopicFrom: string;
  @Input() set data(value: SliderModel) {
    value['slide'] = typeof value['slide'] !== 'undefined' ? this._convertSlideFormat(value['slide']) : [];

    this._data = value;

    if (this._data && this._data['slide'].length > 0) {
      this._viewportWidth = ((<any> this._data)['slide'].length * this._articleWidth);
      this.itemsContainerStyleObject = { width: this._viewportWidth + 'px' };

      if (this.slider['nativeElement']) {
        this._list = this.slider['nativeElement'].querySelectorAll('.viewport')[0].querySelectorAll('div')[0].getElementsByTagName('ul')[0];
        this._width = this._articleWidth > this.slider['nativeElement'].offsetWidth ? this._articleWidth : this.slider['nativeElement'].offsetWidth;
        this._displayControls();
      }
    }

  }

  public itemsContainerStyleObject: Object = { width: 'calc(310px * 9)'};
  public isNextDisabled: boolean = true;
  public showControls: boolean = true;
  public isPreviousDisabled: boolean = true;

  private _data: SliderModel = new SliderModel('', '', []);
  private _list: HTMLUListElement;
  private _width: number;
  private _viewportWidth: number;
  private _articleWidth: number = 310;
  private _position: number = 0;
  private _adj: number = 0;
  private _profile: string = this._appState.get('current_profile') || '';

  constructor (
    private _element: ElementRef,
    private _appState: AppState
  ) {}

  @HostListener('window:resize', ['$event']) public onWindowResize (_event: Event): void {
    this._width = this._articleWidth > this.slider['nativeElement'].offsetWidth ? this._articleWidth : this.slider['nativeElement'].offsetWidth;
    this._displayControls();
  }

  public ngOnInit () {

    this._appState.stateStatus.subscribe((state) => {
      if (typeof state['current_profile'] !== 'undefined' && this._profile === '') {
        this._profile = state['current_profile'];
        this.viewData['slide'] = this._convertSlideFormat(this.viewData['slide']);
      }
    });

    this.isNextDisabled = false;

  }

  public moveCarousel (direction: string) {
    const gaCategory = this._appState.get('gaSearchFrom');
    if (dataLayer && Array.isArray(dataLayer)) {
      if (gaCategory) {
        dataLayer.push({
          'event': 'ImageSlider',
          'category': gaCategory,
          'action': 'Carousel',
          'label': direction
        });
      } else if (this.gaRelatedTopicFrom) {
        dataLayer.push({
          'event': 'ImageSlider',
          'category': this.gaRelatedTopicFrom,
          'action': 'Carousel',
          'label': direction
        });
      } else {
        //search bookmarked url or browser refresh
        dataLayer.push({
          'event': 'ImageSlider',
          'category': 'Results',
          'action': 'Carousel',
          'label': direction
        });
      }
    }

    const pos: number = this.updatePosition(direction);
    this.isPreviousDisabled = false;
    this.isNextDisabled = false;

    if (pos === 0) {
      this.isPreviousDisabled = true;
    } else if ((this._position * -1) >= (this._viewportWidth - this._adj)) {
      this.isNextDisabled = true;
    }

    Velocity(this.slider['nativeElement'].getElementsByTagName('ul')[0], { left: pos.toString() + 'px' }, 600);
  }

  public updatePosition (direction: string): number {
    const num = Math.floor(this._width / this._articleWidth);

    this._adj = num * this._articleWidth;

    if (direction === 'next') {
      this._position = this._position - this._adj;
    } else if (direction === 'previous') {
      this._position = this._position + this._adj;
    }

    if (this._position >= 0) {
      this._position = 0;
    } else if ((this._position * -1) >= (this._viewportWidth - this._adj)) {
      this._position = (this._viewportWidth - this._adj) * -1;
    }

    return this._position;
  }

  public pushSuggestedImageToGA(slide: Object) {
    if (this.viewData) {
      let gaCategory = this._appState.get('gaSearchFrom');
      let slideRank = this.viewData.slide.indexOf(slide);
      slideRank = slideRank + 1;
      if (dataLayer && Array.isArray(dataLayer)) {
        if (gaCategory) {
          dataLayer.push({
            'event': 'ImageSlider',
            'category': gaCategory,
            'label': 'Suggested RT',
            'action': 'Investigate',
            'position': slideRank
          });
        } else if (this.gaRelatedTopicFrom) {
          dataLayer.push({
            'event': 'ImageSlider',
            'category': this.gaRelatedTopicFrom,
            'label': slide[ 'label' ],
            'action': 'Investigate',
            'position': slideRank
          });
        } else {
          //search bookmarked url or browser refresh
          dataLayer.push({
            'event': 'ImageSlider',
            'category': 'Results',
            'label': 'Suggested RT',
            'action': 'Investigate',
            'position': slideRank
          });
        }
      }
    }
  }

  private _convertSlideFormat (slides: object[]): object[] {
    let data = [];

    slides.forEach((slide) => {
      let updatedSlide = {};
      let urlData = [];

      if (this._profile && urlData[0] !== this._profile) {
        urlData.push(this._profile);
      }

      if (typeof slide['url'] !== 'undefined') {
        urlData = urlData.concat(slide['url'].split('/'));
      } else if (typeof slide['nodeId'] !== 'undefined') {
        urlData.push('document');
        urlData.push(slide['nodeId']);
      }

      // remove empty strings from the array
      urlData = urlData.filter((val) => val !== '' );

      updatedSlide['label'] = slide['label'] || slide['nodeName'];
      updatedSlide['imgUrl'] = slide['imgUrl'] || slide['thumbNailImgPath'];
      updatedSlide['url'] = '/' + urlData.join('/');

      data.push(updatedSlide);
    });

    return data;
  }

  private _displayControls (): void {
    const itemsWidth = this._articleWidth * this.viewData.slide.length;

    if (this._width >= itemsWidth) {
      this.showControls = false;

      // reset the position of the image slider to zero when there is a small amount of slides in
      // order to prevent slides from being hidden off screen when the controls are
      // hidden on browser window resize
      if (this._position < 0) {
        this._position = 0;
        Velocity(this.slider['nativeElement'].getElementsByTagName('ul')[0], { left: this._position.toString() + 'px' }, 600);
      }

    } else {
      this.showControls = true;
    }
  }

  get viewData(): SliderModel {
    return this._data;
  }
}
